import React, { useState } from 'react';
import { connect } from 'react-redux';
import serialize from 'serialize-javascript';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { setCookie } from '../../../scripts/utilities/helpers';
import TranslatedCopy from '../../intl/translated-copy';
import Btn from '../global/button';
import {
  closeModalCorporate,
  setChangeCorporateCompany,
  setCompanySelected,
  setCorporateSupplierSelected,
  setFlowCorporateIsActive,
} from '../../../redux/actions/index';

const mapStateToProps = state => ({
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
  isSignIn: state.UserProfileSession.isSignIn,
  language: state.Manage.language,
  storeFront: state.Manage.storefront,
  userCorporate: state.Corporate.userCorporate,
  userProfile: state.UserProfileSession,
});

const ModalCorporateChangeCompany = (props) => {
  const {
    dispatch,
    openCorporateModals,
    userCorporate,
    userProfile,
  } = props;

  const [activeSelect, setActiveSelect] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [companySelected, setCompanySelectedFlow] = useState('PRO_SELECT_MODAL');
  const [radioSelected, setRadioSelected] = useState('');

  const name = userProfile?.userFirstName;
  const ffNumber = userProfile?.userProfile?.ffNumber;
  const isCompanys = userCorporate?.companies;
  const companysArray = isCompanys?.getCompanies() || [];
  const companySelectName = companySelected !== 'CORP_PRO_MODAL_SELECT' && companySelected;
  const classSelect = cx ({
    'BookerSelect-button': true,
    'UserProfile-Corporate-Select': true,
    'is-active': activeSelect,
  });

  openCorporateModals();

  const renderModalHeader = (
    <section className='UserProfile-Corporate-Header'>
      <section className='UserProfile-Corporate-info'>
        <TranslatedCopy
          className='UserProfile-Corporate-headerName'
          copyID='PRO_CORPORATE_HEADER_HELLO'
          tagName='h3'
        />
        <h3 className='UserProfile-Corporate-headerName'>
          { name }
        </h3>
      </section>
      <section className='UserProfile-Corporate-info'>
        <TranslatedCopy 
          copyID='CORP_PRO_MODAL_FFNUMBER'
          tagName='p'
        />
        <strong className='UserProfile-Corporate-ffnumber'>No. { ffNumber } </strong> 
      </section>
    </section>
  );

  const renderModalBody = (
    <section className='UserProfile-Corporate-Body UserProfile-Corporate-BodyMultiCompany'>
      <div>
        <div className='UserProfile-Corporate-sectionCorporate'>
          <TranslatedCopy
            className='UserProfile-Corporate-txtRadioButtons'
            copyID='PRO_CORPORATE_MODAL'
            tagName='p'
          />
        </div>
        { companysArray.length > 1 && selectCompany() }
        <Btn
          btnType='submit'
          className='UserProfile-Corporate-Btn'
          copyID='APP_SAVE'
          disabled={ buttonDisabled }
          filledRed={ true }
          onBtnClick={ () => handleSubmit() }
          visuallyDisabled={ buttonDisabled }
        />
      </div>
    </section>
  );

  const renderModalFooter = (
    <div className='UserProfile-Corporate-Footer'>
      <TranslatedCopy
        copyID='PRO_PREMIERPOINTS_MODAL'
        tagName='p'
      />
    </div>
  );

  function selectCompany() {
    return (
      <>
        <div className='UserProfile-Corporate-Select-Content'>
          <TranslatedCopy className='UserProfile-Corporate-Select-Label-2' copyID='PRO_SELECT_LOGIN' />
          <button
            className={ classSelect }
            id='select'
            onClick={ () => handleSelect(activeSelect) }>
            <TranslatedCopy  copyID={ companySelectName } />
            <span className='Icon Icon--arrowSmallDown arrowIsHomeBooker'/>
          </button>
          { activeSelect &&
            <div className='UserProfile-Corporate-Select-List'>
              { getListCompanys() }
            </div>
          }
        </div>
      </>
    );
  }

  function getListCompanys() {
    return companysArray.map((company, i ) => {
      return (
        <div
          className='UserProfile-Corporate-Select-List-Item'
          key={ i }
          onClick={ () => handleSelectCompany(company?.name) } >
          { company?.name }
        </div>
      );
    });
  }

  function handleSelect(activeSelect) {
    setActiveSelect(!activeSelect);
  }

  function handleSelectCompany(companySelect) {
    setButtonDisabled(false);
    setCompanySelectedFlow(companySelect);
    setRadioSelected('corporate');
    setActiveSelect(false);
  }

  function handleSubmit() {
    let objectCookie = {};
    const corporateRadioSelect = radioSelected === 'corporate' ? true : false;

    if ( corporateRadioSelect ) {
      const supplier = 'nutravel';
      const company = corporateRadioSelect ? companySelected !== 'PRO_SELECT_MODAL' ? companySelected : userCorporate.companies.getNameCompany() : '';
      dispatch(setFlowCorporateIsActive(true));
      dispatch(setCompanySelected(company));
      dispatch(setCorporateSupplierSelected(supplier));
      localStorage.setItem('userCorporateCompany', company);
      localStorage.setItem('corporateSupplierSelected', supplier);
      objectCookie = { ...objectCookie, isUserCorporate: corporateRadioSelect };
      setCookie('userSessionCorporate', serialize(objectCookie));
      localStorage.setItem('companySelected', company);
      objectCookie = { ...objectCookie, companySelected: company };
    }

    localStorage.setItem('userIsCorporate', corporateRadioSelect);
    localStorage.setItem('experienceSelect', radioSelected);

    dispatch(closeModalCorporate());
    onCloseModal();
  }

  function onCloseModal() {
    const htmlTag = document.getElementsByTagName('html')[0];

    htmlTag.classList.remove('Modal-open--state');
    if (localStorage.hasOwnProperty('position')) {
      const position = localStorage.getItem('position');
      window.scrollTo(0, position);
    }
    dispatch(setChangeCorporateCompany(false));
  }

  return (
    <div className='modal-Corporate'>
      <div className='Modal-inner-Corporate'>
        <div className='Modal-body-login Modal-body--isOpen Modal-body--regular has-noDefaultTopBar' tabIndex='0'>
          <div className='UserProfile-Corporate'>
            { renderModalHeader }
            { renderModalBody }
            { renderModalFooter }
          </div>
        </div>
      </div>
    </div>
  );
};

ModalCorporateChangeCompany.propTypes = {
  userProfile: PropTypes.object.isRequired,
  userCorporate: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  openCorporateModals: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ModalCorporateChangeCompany);
